import { createApi } from "@reduxjs/toolkit/query/react";
import { createQuery } from "@/shared/helpers/create-query.helper";
import { axiosBaseQuery } from "@/shared/api/base-services-axios-rtx";
import { GeoLocalizationEndpoints } from "../../endpoints/get-location.endpoints";
import { ICountriesResponse } from "./responses/get-countries.response";
import { GetCountriesValuesQRTK } from "./values/get-countries.values";
import { GetCitiesValuesQRTK } from "./values/get-cities.values";
import { IGetCitiesResponse } from "./responses/get-cities.response";
import { IGetSectorsReponse as IGetSectorsResponse } from "./responses/get-sectors.response";
import { GetSectorsValuesQRTK } from "./values/get-sectors.values";
import { mainSplitApi } from "../../mainSplitApi";
import GEO_LOCATION_TAG_TYPES from "./geoLocation.tags";

export const GeoLocationQueryServices = createApi({
  reducerPath: "geo-location-rfc",
  baseQuery: axiosBaseQuery(),

  endpoints: builder => ({
    getCountries: builder.mutation({
      query: (values: GetCountriesValuesQRTK) => ({
        url: GeoLocalizationEndpoints.countriesList + createQuery(values.query),
        method: "GET"
      }),
      transformResponse: (response: ICountriesResponse, meta, arg) => {
        return response.data;
      }
    }),
    getCountriess: builder.query({
      query: (values: GetCountriesValuesQRTK) => ({
        url: GeoLocalizationEndpoints.countriesList + createQuery(values.query),
        method: "GET"
      }),
      transformResponse: (response: ICountriesResponse, meta, arg) => {
        return response.data;
      }
    }),
    getCitiesM: builder.mutation({
      query: (values: GetCitiesValuesQRTK) => ({
        url: GeoLocalizationEndpoints.citiesList + createQuery(values.query),
        method: "GET"
      }),
      transformResponse: (response: IGetCitiesResponse, meta, arg) =>
        [
          { name: "DISTRITO NACIONAL", id: "1" }, // no remplazar debido a que es un item duplicado y con label diferente
          ...response.data?.map(x => ({ name: x.description, id: x.id }))
        ] as { name: string; id: any }[]
    }),

    getCities: builder.query({
      query: (values: GetCitiesValuesQRTK) => ({
        url: GeoLocalizationEndpoints.citiesList + createQuery(values.query),
        method: "GET"
      }),
      transformResponse: (response: IGetCitiesResponse, meta, arg) =>
        [
          { label: "DISTRITO NACIONAL", value: "1" }, // no remplazar debvalueo a que es un item duplicado y con label diferente
          ...response.data?.map(x => ({
            label: x.description,
            value: x.id
          }))
        ] as { label: string; value: any }[]
    }),

    getSectors: builder.mutation({
      query: (values: GetSectorsValuesQRTK) => ({
        url: GeoLocalizationEndpoints.sectorsList + createQuery(values.query),
        method: "GET"
      }),
      transformResponse: (response: IGetSectorsResponse, meta, arg) =>
        response.data?.map(x => ({
          name: x.description,
          id: x.id,
          cityName: x.city?.description ?? ""
        }))
    })
  })
});

export const GeoLocationQueryServicesRf = mainSplitApi.injectEndpoints({
  endpoints: ({ mutation, query }) => ({
    GetSectors: query<IGetSectorsResponse, GetSectorsValuesQRTK>({
      query: values => ({
        url: GeoLocalizationEndpoints.sectorsList,
        method: "GET",
        params: values.query
      }),
      providesTags: [GEO_LOCATION_TAG_TYPES.GEO_LOCATION_GET_SECTORS]
    }),
    getCities: query<IGetCitiesResponse, GetCitiesValuesQRTK>({
      query: values => ({
        url: GeoLocalizationEndpoints.citiesList,
        method: "GET",
        params: values.query
      })
    }),
    getCountries: query<ICountriesResponse, GetCountriesValuesQRTK>({
      query: values => ({
        url: GeoLocalizationEndpoints.countriesList,
        method: "GET",
        params: values.query
      }),
      transformResponse: (response: ICountriesResponse) => response
    })
  })
});

export const { useGetSectorsQuery, useLazyGetCitiesQuery, useGetCountriesQuery } =
  GeoLocationQueryServicesRf;
/**
 * @deprecate
 */
export const {
  useGetSectorsMutation,
  useGetCitiesMMutation,
  useGetCitiesQuery,
  useGetCountriesMutation,

  useGetCountriessQuery
} = GeoLocationQueryServices;
